import React from 'react';
import {
    Typography,
    Button,
    Space,
    Card,

    Alert,
    Row,
    Col,
    Divider,
    Tag
} from 'antd';
import {
    HomeOutlined,
    ReloadOutlined,
    BugOutlined,

    CloseCircleOutlined
} from '@ant-design/icons';
import { Helmet } from 'react-helmet';
import { isDevelopment, isProduction } from 'src/module/helpers';

const { Title, Text, Paragraph } = Typography;

export default function PageError({ error, resetErrorBoundary, history }) {
    const colorPrimary = '#1890ff';
    const colorPrimaryActive = '#40a9ff';

    const goHome = () => {
        resetErrorBoundary();
        window.location.href = '/';
    };

    const onReload = () => {
        resetErrorBoundary();
        window.location.reload();
    };

    // Mendapatkan pesan error yang lebih friendly
    const getErrorMessage = () => {
        if (error?.message?.includes('Network Error')) {
            return {
                title: 'Koneksi Gagal',
                subTitle: 'Tidak dapat terhubung ke server. Periksa koneksi internet Anda.',
                type: 'warning'
            };
        }
        if (error?.message?.includes('404')) {
            return {
                title: 'Halaman Tidak Ditemukan',
                subTitle: 'Maaf, halaman yang Anda cari tidak tersedia.',
                type: 'warning'
            };
        }
        if (error?.message?.includes('403')) {
            return {
                title: 'Akses Ditolak',
                subTitle: 'Anda tidak memiliki izin untuk mengakses halaman ini.',
                type: 'error'
            };
        }
        return {
            title: 'Terjadi Kesalahan',
            subTitle: 'Maaf, telah terjadi kesalahan pada sistem.',
            type: 'error'
        };
    };

    const errorInfo = getErrorMessage();

    console.error(error)

    return (
        <div style={{
            minHeight: '100vh',
            background: 'linear-gradient(135deg, #4C7768 0%, #5B8F78 55%, #6FA7A6 100%)',
            display: 'flex',
            alignItems: 'center',
            padding: '24px'
        }}>
            <Helmet>
                <title>Error | PT SARANA KAWAN SETIA</title>
            </Helmet>

            <div style={{ maxWidth: 1200, margin: '0 auto', width: '100%' }}>
                <Row justify="center" align="middle">
                    <Col xs={24} md={20} lg={16}>
                        <Card
                            style={{
                                borderRadius: 24,
                                overflow: 'hidden',
                                boxShadow: '0 20px 40px rgba(0,0,0,0.1)',
                                backdropFilter: 'blur(10px)',
                                background: 'rgba(255,255,255,0.95)'
                            }}
                            bodyStyle={{ padding: 48 }}
                        >
                            {/* Error Icon & Header */}
                            <div style={{ textAlign: 'center', marginBottom: 32 }}>
                                <div style={{
                                    width: 120,
                                    height: 120,
                                    background: `linear-gradient(135deg, ${colorPrimary}20, ${colorPrimaryActive}20)`,
                                    borderRadius: '50%',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    margin: '0 auto 24px'
                                }}>
                                    <BugOutlined style={{ fontSize: 64, color: colorPrimary }} />
                                </div>

                                <Title level={2} style={{ marginBottom: 8, color: '#1a1a1a' }}>
                                    {errorInfo.title}
                                </Title>

                                <Tag
                                    icon={<CloseCircleOutlined />}
                                    color="error"
                                    style={{ fontSize: 14, padding: '4px 12px', marginBottom: 16 }}
                                >
                                    Error Code: {error?.response?.status || '500'}
                                </Tag>

                                <Paragraph style={{ fontSize: 16, color: '#666', maxWidth: 500, margin: '0 auto' }}>
                                    {errorInfo.subTitle}
                                </Paragraph>
                            </div>

                            {/* Error Detail */}
                            {isProduction ? (
                                <Alert
                                    message="Terjadi Kesalahan"
                                    description="Terjadi kesalahan pada sistem. Silakan coba kembali atau hubungi tim support."
                                    type="error"
                                    showIcon
                                    style={{
                                        borderRadius: 16,
                                        marginBottom: 32,
                                    }}
                                />
                            ) : (
                                error &&
                                isDevelopment &&
                                error.toString() !== 'Error: Network Error' && (
                                    <Alert
                                        message="Detail Error"
                                        description={error.toString()}
                                        type={errorInfo.type === 'error' ? 'error' : 'warning'}
                                        showIcon
                                        style={{
                                            borderRadius: 16,
                                            marginBottom: 32,
                                            background: '#fafafa',
                                        }}
                                        closable
                                    />
                                )
                            )}


                            {/* Saran Perbaikan */}
                            <div style={{ marginBottom: 32 }}>
                                <Title level={5} style={{ textAlign: 'center', marginBottom: 16 }}>
                                    💡 Saran Perbaikan
                                </Title>
                                <Row gutter={[16, 16]}>
                                    <Col xs={24} sm={8}>
                                        <Card
                                            size="small"
                                            style={{
                                                borderRadius: 12,
                                                textAlign: 'center',
                                                background: '#f8f9fa'
                                            }}
                                        >
                                            <Text>1. Periksa koneksi internet</Text>
                                        </Card>
                                    </Col>
                                    <Col xs={24} sm={8}>
                                        <Card
                                            size="small"
                                            style={{
                                                borderRadius: 12,
                                                textAlign: 'center',
                                                background: '#f8f9fa'
                                            }}
                                        >
                                            <Text>2. Refresh halaman</Text>
                                        </Card>
                                    </Col>
                                    <Col xs={24} sm={8}>
                                        <Card
                                            size="small"
                                            style={{
                                                borderRadius: 12,
                                                textAlign: 'center',
                                                background: '#f8f9fa'
                                            }}
                                        >
                                            <Text>3. Hubungi tim support</Text>
                                        </Card>
                                    </Col>
                                </Row>
                            </div>

                            <Divider style={{ marginBottom: 32 }} />

                            {/* Action Buttons */}
                            <Space direction="vertical" size="middle" style={{ width: '100%' }}>
                                <Button
                                    type="primary"
                                    size="large"
                                    icon={<HomeOutlined />}
                                    onClick={goHome}
                                    style={{
                                        height: 48,
                                        borderRadius: 12,
                                        fontSize: 16,
                                        backgroundColor: colorPrimary,
                                        borderColor: colorPrimary,
                                        width: '100%'
                                    }}
                                >
                                    Kembali ke Beranda
                                </Button>

                                <Button
                                    size="large"
                                    icon={<ReloadOutlined />}
                                    onClick={onReload}
                                    style={{
                                        height: 48,
                                        borderRadius: 12,
                                        fontSize: 16,
                                        width: '100%'
                                    }}
                                >
                                    Muat Ulang Halaman
                                </Button>
                            </Space>

                            {/* Footer */}
                            <div style={{ textAlign: 'center', marginTop: 32 }}>
                                <Text type="secondary" style={{ fontSize: 12 }}>
                                    Jika masalah berlanjut, silakan hubungi tim support kami di{' '}
                                    <a href="mailto:aidan@ihore.id">aidan@ihore.id</a>
                                </Text>
                            </div>
                        </Card>
                    </Col>
                </Row>
            </div>
        </div>
    );
}